module.exports = __webpack_public_path__ + "img/42.2cf65657.png";